import { Dialog } from "~/components/Backroom/Dialog";
import Button from "~/components/Button";
import { StoreContact } from "~/pages/products/[productId]/StoreContact";
import { StrapiStore } from "~/shared-types";

type Props = {
  store?: StrapiStore | null;
};

export const ContactDialog = ({ store }: Props) => {
  const publicEmail = store?.attributes.publicEmail;
  const publicPhone = store?.attributes.publicPhone;

  if (!publicEmail && !publicPhone) return null;

  return (
    <Dialog
      trigger={
        <Button variant="primary" size="lg">
          Kontakt sælger
        </Button>
      }
      className="px-12 py-10"
      closeClassName="!top-2 !right-2"
    >
      <StoreContact store={store} />
    </Dialog>
  );
};
